import { Component, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { maps_vector_lang } from "../../language/maps_vector";
import * as L from 'leaflet';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { thLocale } from 'ngx-bootstrap/locale';
defineLocale('engb', enGbLocale);
defineLocale('th', thLocale);
declare var url;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

class map_vector {
  place_id: string;
  place_address: string;
  place_type_description: string;
  fee_description: string;
  fee_count: number;
  fee_type_unit: string;
  fee_price: number;
  customer_name: string;
}

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit {
  token = '';
  database = '';
  dtOptions: DataTables.Settings = {};
  map_vectors: map_vector[];
  enable_google = false;
  map;
  lat = 12.99671;
  lon = 100.935759;
  marker;
  isLoading = true;
  showPage = false;
  lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";
  language: any;

  constructor(
    private http: HttpClient,
    private service: MyserviceService,
    private chRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private localeService: BsLocaleService,
    private router: Router,
    private modalService: BsModalService) {
    this.language = maps_vector_lang[this.lang];
  }

  ngOnInit() {

    if (sessionStorage.getItem('municipality') != undefined) {
      this.database = JSON.parse(sessionStorage.getItem('municipality')).municipality_id + '_fee'
    }

    if (sessionStorage.getItem('token') != undefined) {
      this.token = sessionStorage.getItem('token');
    }

    this.isLoading = false;
    this.showPage = true;
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        console.log('customer-place/place-vectormap_to_datatable')
        that.http
          .post<DataTablesResponse>(
            url + 'customer-place/place-vectormap_to_datatable',
            dataTablesParameters, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8',
              'x-access-token': this.token,
              'database': this.database
            })
          }
          ).subscribe(resp => {
            //debugger
            that.map_vectors = resp.data.map((item) => {
              return item;
            });
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [{ data: 'cp.place_id' }, { data: 'cp.place_address' }, { data: 'ct.place_type_description' }, { data: 'fm.fee_description' },
      { data: '(fm.fee_price :: VARCHAR)' }, { data: 'customer_name' }]
    };

    this.route.queryParams.subscribe(params => {
      this.lang = params['lang'];
      if (this.lang != 'EN' && this.lang != 'TH') {
        this.lang = localStorage.getItem('lang') == 'EN' ? 'EN' : 'TH';
        this.language = maps_vector_lang[this.lang];
      } else {
        this.language = maps_vector_lang[this.lang];
        localStorage.setItem('lang', this.lang);
      }
    });
  }

  ngAfterViewInit(): void {
    this.initMap();
  }

  private initMap(): void {
    var streets_satellite = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: 'Mapbox',
      tileSize: 512,
      zoomOffset: -1,
      id: 'mapbox/satellite-v9',
      accessToken: 'pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw'
    })
    // ===================================================================================
    var mapbox_streets = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: 'Mapbox',
      tileSize: 512,
      zoomOffset: -1,
      id: 'mapbox/streets-v11',
      accessToken: 'pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw'
    })
    var wmslayer = L.tileLayer.wms('http://203.150.210.26:8080/DeeMap_Msd01/gwc/service/wms', {
      layers: 'cite:Pattaya',
      format: 'image/png8',
      transparent: true,
    })

    var polygon = L.tileLayer.wms('http://203.150.210.26:8080/DeeMap_Msd01/gwc/service/wms', {
      layers: 'pattaya_200463',
      format: 'image/png8',
      transparent: true,
    })

    var baseLayers = {
      "Satellite_mapbox": streets_satellite,
      "Streets_mapbox": mapbox_streets
    };

    this.map = L.map('map', {
      center: [this.lat, this.lon],
      zoom: 20,
      layers: [streets_satellite]
    });

    var layerControl = L.control.layers(baseLayers).addTo(this.map);
    // layerControl.addOverlay(wmslayer.addTo(this.map), 'Map Service Drone');
    // layerControl.addOverlay(polygon.addTo(this.map), 'ขอบเขต');
    this.marker = L.marker([this.lat, this.lon]).addTo(this.map);
  }


  onClickRow(item) {
    this.lat = item.lat;
    this.lon = item.lon;
    if (this.marker) { // check
      this.map.removeLayer(this.marker); // remove
      this.map.removeControl(this.marker); // remove
      this.marker = L.marker([this.lat, this.lon]).addTo(this.map);
      this.map.panTo([this.lat, this.lon]);
    }

  }
}